export const dispatchEvent = (name, detail) => {
	const data = {
		bubbles: false,
		cancelable: false,
		detail: detail || null,
	};
	let E = window.CustomEvent;
	if (typeof E !== 'function') {
		// eslint-disable-next-line
		function FakeEvent(name, data) {
			const e = document.createEvent('CustomEvent');
			e.initCustomEvent(name, data.bubbles, data.cancelable, data.detail);
			return e;
		}
		FakeEvent.prototype = window.Event.prototype;
		E = FakeEvent;
	}
	const event = new E(name, data);
	window.dispatchEvent(event);
};
